import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setEstimateData, setEstimateError } from "../reducers/EstimateList";
import type {
  EstimateData as EstimateDataState,
  GetEstimateDataRequest,
  GetEstimateDataResponse,
  GetEstimateVersionsLatestResponse,
} from "@ServerTypes/estimates/estimates.schema";
import { errorCodes } from "@Helpers/errorCodes";
import type { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import type { RootState } from "src/reducers";

type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const getEstimateDataAction = setEstimateData;

export interface GetEstimateDataProp {
  estimateId: string;
  versionId?: string;
}

export function getEstimateData({ estimateId, versionId }: GetEstimateDataProp) {
  return async (dispatch: AppDispatch) => {
    const data: GetEstimateDataRequest = { _id: estimateId, versionId };
    const response = await axiosWrapper.post<GetEstimateDataResponse>(
      `${getBackendUrl()}/estimate/getEstimateData`,
      data,
    );

    if (response.data.status) {
      const resData = response.data.result as EstimateDataState;
      dispatch(setEstimateError(false));
      dispatch(getEstimateDataAction(resData));
    } else {
      dispatch(setEstimateError((response.data.errorCode || errorCodes.SOMETHING_WENT_WRONG) as number));
    }
  };
}

export async function getEstimateVersionsLatest({ estimateId }: GetEstimateDataProp) {
  const response = await axiosWrapper.post<GetEstimateVersionsLatestResponse>(
    `${getBackendUrl()}/estimate/getEstimateVersionsLatest`,
    {
      estimateId,
    },
  );
  return response.data.result;
}
